import { replaceRequestIdentity } from './replaceRequestIdentity';
import { WidgetEvent } from '../../../../models/Widget/events/WidgetEvent';

/**
 * Обрабатывает массив событий виджета и заменяет identity
 * во всех действиях, которые содержат `requestIdentity`.
 */
export function processEventsArray(
  events: Array<WidgetEvent>,
  newId: string | null,
): Array<WidgetEvent> {
  return events.map((event) => {
    if (!Array.isArray(event.actions)) {
      return event;
    }

    return {
      ...event,
      actions: event.actions.map((action) => {
        if (!action.requestIdentity) {
          return action;
        }

        return {
          ...action,
          requestIdentity: replaceRequestIdentity(action.requestIdentity, newId),
        };
      }),
    };
  });
}
